import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
// import { useAuth } from "../../app/useAuth";
import MainLayout from "../../components/layouts/main";

export default function N5Records() {
    // const auth = useAuth();
    const navigate = useNavigate();
    const [textSearch, setTextSearch] = useState("");
    const [submitSearch, setSubmitSearch] = useState(false);
    const [advancedSearch, setAdvancedSearch] = useState("all");
    const [advancedSearchText, setAdvancedSearchText] = useState("");

    const handleSubmitSearch = useCallback(() => {
        const checkAdvancedSearchObject = JSON.stringify(advancedSearchText) === JSON.stringify({});
        if (checkAdvancedSearchObject) {
            navigate(`/search/n5/${textSearch ? textSearch : advancedSearchText}`);
        } else {
            const urlParams = new URLSearchParams(advancedSearchText).toString();
            navigate(`/search/n5/advanced?${urlParams}`);
        }
        setSubmitSearch(false);
    }, [textSearch, navigate, advancedSearch, advancedSearchText]);

    useEffect(() => {
        if (submitSearch) {
            handleSubmitSearch();
        }
    }, [submitSearch, handleSubmitSearch]);

    const arrRules = [
        {
            title: "Chromosome No",
            value: "chromosome_no",
        },
        {
            title: "Position Start",
            value: "position_start",
        },
    ];

    return (
        <MainLayout
            pathname="/search/n5"
            arrRules={arrRules}
            header="Gene"
            exampleText={
                <div>
                    Examples - Gene ID:
                    <span className="text-primary"> Os01g0100100</span>, <span className="text-primary">Os01g0105700</span> Position: <span className="text-primary">1-2983</span>
                </div>
            }
            textSearch={textSearch}
            setTextSearch={setTextSearch}
            setSubmitSearch={setSubmitSearch}
            setAdvancedSearch={setAdvancedSearch}
            advancedSearchText={advancedSearchText}
            setAdvancedSearchText={setAdvancedSearchText}
        />
    );
}
